const firebaseConfig = {
  apiKey: "AIzaSyBx0GIlcE2HRSulTY9lp14eViZltO312aE",
  authDomain: "cookbook-53824.firebaseapp.com",
  projectId: "cookbook-53824",
  storageBucket: "cookbook-53824.appspot.com",
  messagingSenderId: "363711045601",
  appId: "1:363711045601:web:6d71267f4772f42a387ca0"
};

export default firebaseConfig;